<template>
  <q-layout view="hHh lpr fff">

    <q-header
      bordered
      class="text-white"
    >
      <q-toolbar>
        <q-toolbar-title>
          <q-avatar>
            <img
              alt="abraao.dev logo"
              src="@/assets/logo.png"
            >
          </q-avatar>
          <span class="text-bold q-pl-sm">abraao.dev</span>
        </q-toolbar-title>
      </q-toolbar>
    </q-header>

    <q-page-container>
      <router-view />
    </q-page-container>

    <main-footer />

  </q-layout>
</template>

<script>
import MainFooter from '@/components/layout/MainFooter'

export default {
  name: 'SimpleLayout',
  components: {
    MainFooter
  },
  data () {
    return {
    }
  }
}
</script>
